/**
 * Leveranstid per produkt. Triscan (TecDoc-märke, vår tillverkare 1222) levererar till oss nästa vardag om de får
 * beställningen före 15:00, och vi har många av deras delar hemma — ägaren 2026-10-07: "Jag vågar påstå 1–2
 * arbetsdagar för Triscan-delar". Övriga leverantörer tar upp till 3–4 dagar till oss, därför 2–5.
 * Leverantörens namn visas aldrig för kunden här — bara tiden.
 */
export const TRISCAN_TILLVERKARE = 1222;

type MedMarke = { id_manufacturer?: number | null; manufacturer_name?: string | null; manufacturer?: { name?: string | null } | null };

export function arTriscan(p: MedMarke | null | undefined): boolean {
  if (!p) return false;
  if (p.id_manufacturer === TRISCAN_TILLVERKARE) return true;
  const namn = p.manufacturer_name ?? p.manufacturer?.name ?? '';
  return namn.trim().toUpperCase() === 'TRISCAN';
}

/** "1–2" eller "2–5" (tankstreck), för texten "Levereras … arbetsdagar". */
export function leveransdagar(p: MedMarke | null | undefined): '1–2' | '2–5' {
  return arTriscan(p) ? '1–2' : '2–5';
}
